import { render, staticRenderFns } from "./editOnlinePageDatasourceRelation.vue?vue&type=template&id=eafbfcce&"
import script from "./editOnlinePageDatasourceRelation.vue?vue&type=script&lang=js&"
export * from "./editOnlinePageDatasourceRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports